import styled from 'styled-components'

export const PlanosContainer = styled.div`
	max-width: 100%;
	overflow-x: auto;
	overscroll-behavior-x: contain;
	scrollbar-color: var(--color-fg) var(--color-bg);
	scroll-snap-type: x mandatory;
	display: grid;
	padding: 1rem;
	scroll-behavior: smooth;
	/* grid-template-columns:
		[full-start] 1fr
		[content-start] 400px
		1fr [full-end]; */

	> ul {
		display: flex;
		align-items: start;
		gap: 2rem;

		> li {
			place-content: center;
			flex-shrink: 0;
			width: 300px;
			aspect-ratio: 4 / 5;
			scroll-snap-align: center;
			
			.react-tabs__tab {
				&:not(.react-tabs__tab--selected) {
					.subtext {
						color: #309212ff !important;
					}
				}
			}
		}
	}

	&::-webkit-scrollbar {
		width: 1px;
	}

	&::-webkit-scrollbar-thumb,
	&::-webkit-scrollbar-track {
		background: transparent;
	}
`